import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
/**
 * * 텍스트 flex
 */

interface IProps {
  children?: JSX.Element | JSX.Element[];
  style?: React.CSSProperties;
}
const TextFlexBox = ({ children, style }: IProps) => {
  return <Container style={style}>{children}</Container>;
};

export default TextFlexBox;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  /* 수정 화면에서 키, 수정하면 안되는 value */
  h6 {
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    font-weight: 600;
    margin-right: 0.8rem;
    margin-left: 0.2rem;
  }
  h5 {
    margin-top: 0.15rem;
    /* margin-left: 0.3rem; */
    font-size: 1rem;
  }
  p {
    font-weight: 700;
  }
`;
